import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import useAuth from "../../../../hooks/useAuth";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

export default function CrudTable({ fields, filteredItems, filters, handleOpen, onDelete }) {
    const { auth } = useAuth();
    const isSuperAdmin = auth ? auth?.primaryUser?.isSuperAdmin : 0;

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);

    const handleMenuOpen = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedItem(item);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = () => {
        handleOpen(selectedItem);
        handleMenuClose();
    };

    const handleDeleteClick = () => {
        setConfirmOpen(true);
        handleMenuClose();
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
        setSelectedItem(null);
    };

    const handleConfirmDelete = () => {
        onDelete(selectedItem.id);
        setConfirmOpen(false);
        setSelectedItem(null);
    };

    return (
        <Box>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {fields.filter(f => !f.hiddenCol).map(f => (
                            <TableCell key={f.name}>{f.label}</TableCell>
                        ))}
                        <TableCell>Activo</TableCell>
                        <TableCell align="right">
                            {isSuperAdmin ? (
                                <span>Acciones</span>
                            ) : null}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredItems
                        .filter(item => {
                            if (filters.isActive === undefined || filters.isActive === "") return true;
                            return Number(item.isActive) === Number(filters.isActive);
                        }).length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={fields.filter(f => !f.hiddenCol).length + 2} align="center">
                                <Box display="flex" alignItems="center" justifyContent="center" py={4} gap={1}>
                                    <SearchOffOutlinedIcon color="action" />
                                    <span>No hay datos para mostrar.</span>
                                </Box>
                            </TableCell>
                        </TableRow>
                    ) : (
                        filteredItems
                            .filter(item => {
                                if (filters.isActive === undefined || filters.isActive === "") return true;
                                return Number(item.isActive) === Number(filters.isActive);
                            })
                            .map(item => (
                                <TableRow key={item.id}>
                                    {fields.filter(f => !f.hiddenCol).map(f => (
                                        <TableCell key={f.name}>
                                            {
                                                f.name === "idProvince"
                                                    ? (item.provinceName || item.idProvince || "")
                                                    : f.name === "idRegion"
                                                        ? (item.regionName || item.idRegion || "")
                                                        : item[f.name]
                                            }
                                        </TableCell>
                                    ))}
                                    <TableCell>
                                        {item.isActive === true ? "Sí" : "No"}
                                    </TableCell>
                                    <TableCell align="right">
                                        {isSuperAdmin ? (
                                            <IconButton size="small" onClick={(e) => handleMenuOpen(e, item)}>
                                                <MoreHorizIcon />
                                            </IconButton>
                                        ) : null}
                                    </TableCell>
                                </TableRow>
                            ))
                    )}
                </TableBody>
            </Table>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={handleEdit}>Editar</MenuItem>
                <MenuItem onClick={handleDeleteClick}>Eliminar</MenuItem>
            </Menu>
            <Dialog open={confirmOpen} onClose={handleConfirmClose}>
                <DialogTitle>Confirmar eliminación</DialogTitle>
                <DialogContent>
                    {`¿Está seguro que desea eliminar este registro${selectedItem?.regionName ? ` de la comunidad "${selectedItem.regionName}"` : ""}?`}
                    <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16, marginTop: 20 }}>
                        <div style={{ width: "50%" }}>
                            <Button
                                onClick={handleConfirmClose}
                                variant="contained"
                                className="MuiButton-containedCancel"
                                fullWidth
                            >
                                Cancelar
                            </Button>
                        </div>
                        <div style={{ width: "50%" }}>
                            <Button
                                onClick={handleConfirmDelete}
                                color="primary"
                                variant="contained"
                                fullWidth
                            >
                                Eliminar
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </Box>
    );
}
